module.exports = __webpack_public_path__ + "static/media/bwdi.cb834f1f.png";